import React, { useMemo, useState } from "react";

const FORM_SUBMIT_EMAIL = "contactos@brightonenglishcenter.edu.co";
const THANK_YOU_URL = "https://brightonenglishcenter.edu.co/gracias";

const steps = [
  { id: 1, name: "Datos personales" },
  { id: 2, name: "Nivel Inglés" },
  { id: 3, name: "Objetivos" },
  { id: 4, name: "Comienza Ahora" },
];

const goalOptions = [
  "Mejorar mi nivel para viajar",
  "Obtener una certificación internacional",
  "Ingresar a una universidad",
  "Mejorar mis oportunidades laborales",
  "Desarrollar comunicación oral",
  "Apoyo académico o escolar",
  "Crecimiento personal",
];

function StepperForm() {
  const [currentStep, setCurrentStep] = useState(1);

  const [formData, setFormData] = useState({
    nombre: "",
    edad: "",
    email: "",
    tel: "",
    conocimientosPrevios: "",
    disponibilidad: "",
    motivos: [],
    mensaje: "",
    diagnostico: "",
    aceptaDatos: false,
  });

  const progress = useMemo(
    () => Math.round((currentStep / steps.length) * 100),
    [currentStep],
  );

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      motivos: checked
        ? [...prev.motivos, value]
        : prev.motivos.filter((item) => item !== value),
    }));
  };

  const handleSingleCheck = (e) => {
    const { name, checked } = e.target;
    setFormData((prev) => ({ ...prev, [name]: checked }));
  };

  return (
    <div className="w-full max-w-5xl bg-white rounded-2xl shadow-custom-first border border-gray-100 overflow-hidden rounded-lg outline  outline-primario">
      {/* STEPPER */}
      <div className="bg-gray-100 p-4 sm:p-6 lg:p-8 outline outline-1 outline-gray-300">
        <div className="flex items-start md:items-center justify-between gap-1 md:gap-2">
          {steps.map((step, index) => (
            <React.Fragment key={step.id}>
              <div className="flex flex-col items-center flex-1 min-w-0">
                <div
                  className={`w-7 h-7 sm:w-10 sm:h-10 flex items-center justify-center rounded-full border-2 font-bold text-sm transition
                    ${
                      currentStep === step.id
                        ? "border-yellow-1 text-yellow-1"
                        : "border-gray-300 text-gray-400"
                    }`}
                >
                  {step.id}
                </div>

                <span
                  className={`text-[10px] sm:text-xs mt-2 font-bold uppercase text-center ${
                    currentStep === step.id ? "text-yellow-1" : "text-gray-400"
                  }`}
                >
                  {step.name}
                </span>
              </div>

              {index !== steps.length - 1 && (
                <div className="w-1 sm:w-2 md:flex-1 h-[2px] bg-gray-300 mx-1 sm:mx-2 self-center" />
              )}
            </React.Fragment>
          ))}
        </div>

        <div className="mt-5 h-1.5 bg-gray-200 rounded-full overflow-hidden">
          <div
            className="h-full bg-yellow-1 transition-all duration-300"
            style={{ width: `${progress}%` }}
          />
        </div>
      </div>

      {/* FORM */}
      <form
        action={`https://formsubmit.co/${FORM_SUBMIT_EMAIL}`}
        method="POST"
        className="p-4 sm:p-6 lg:p-8  space-y-4"
      >
        {/* CONFIG */}
        <input
          type="hidden"
          name="_subject"
          value="Nuevo registro pagina web - Brighton Centro de Inglés"
        />
        <input type="hidden" name="_next" value={THANK_YOU_URL} />
        <input type="hidden" name="_template" value="table" />
        <input type="text" name="_honey" style={{ display: "none" }} />
        {/* HIDDEN */}
        <input type="hidden" name="nombre" value={formData.nombre} />
        <input type="hidden" name="edad" value={formData.edad} />
        <input type="hidden" name="email" value={formData.email} />
        <input type="hidden" name="tel" value={formData.tel} />
        <input
          type="hidden"
          name="conocimientosPrevios"
          value={formData.conocimientosPrevios}
        />
        <input
          type="hidden"
          name="disponibilidad"
          value={formData.disponibilidad}
        />
        <input
          type="hidden"
          name="motivos"
          value={formData.motivos.join(", ")}
        />
        <input type="hidden" name="mensaje" value={formData.mensaje} />
        <input type="hidden" name="diagnostico" value={formData.diagnostico} />
        <input
          type="hidden"
          name="aceptaDatos"
          value={formData.aceptaDatos ? "Sí" : "No"}
        />

        {/* STEP 1 */}
        {currentStep === 1 && (
          <div className="space-y-6">
            <h3 className="text-2xl sm:text-3xl font-bold text-primario border-l-4 border-yellow-1 pl-3">
              Información Personal
            </h3>
            <p className="text-base">
              Cuéntanos un poco sobre quién esta interesado en tomar el curso.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <input
                type="text"
                name="nombre"
                placeholder="Nombre completo"
                value={formData.nombre}
                onChange={handleChange}
                required
                className="w-full p-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-yellow-1 focus:border-yellow-1"
              />
              <input
                type="number"
                name="edad"
                placeholder="Edad"
                min={1}
                value={formData.edad}
                onChange={handleChange}
                required
                className="w-full p-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-yellow-1 focus:border-yellow-1"
              />
              <input
                type="email"
                name="email"
                placeholder="Correo"
                value={formData.email}
                onChange={handleChange}
                required
                className="w-full p-3 rounded-lg border border-gray-300 md:col-span-2 focus:outline-none focus:ring-2 focus:ring-yellow-1 focus:border-yellow-1"
              />
              <input
                type="tel"
                name="tel"
                placeholder="Teléfono"
                value={formData.tel}
                onChange={handleChange}
                className="w-full p-3 rounded-lg border border-gray-300 md:col-span-2 focus:outline-none focus:ring-2 focus:ring-yellow-1 focus:border-yellow-1"
              />
            </div>
          </div>
        )}

        {/* STEP 2 */}
        {currentStep === 2 && (
          <div className="space-y-6">
            <h3 className="text-2xl sm:text-3xl font-bold text-primario border-l-4 border-yellow-1 pl-3">
              Experiencia y disponibilidad
            </h3>
            <p className="text-base">
              Describe brevemente si tienes conocimientos previos en el idioma.
            </p>
            <textarea
              name="conocimientosPrevios"
              value={formData.conocimientosPrevios}
              onChange={handleChange}
              placeholder="Describe tus conocimientos previos..."
              required
              className="w-full p-3 rounded-lg border border-gray-300 min-h-[120px] focus:outline-none focus:ring-2 focus:ring-yellow-1 focus:border-yellow-1"
            />
            <p>Cual es tu disponibilidad de tiempo para aprender inglés</p>
            <select
              name="disponibilidad"
              value={formData.disponibilidad}
              onChange={handleChange}
              required
              className="w-full p-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-yellow-1 focus:border-yellow-1"
            >
              <option value="">Disponibilidad</option>
              <option>Mañanas</option>
              <option>Tardes</option>
              <option>Noches</option>
              <option>Fines de semana</option>
            </select>
          </div>
        )}

        {/* STEP 3 */}
        {currentStep === 3 && (
          <div className="grid grid-cols-2 gap-3">
            <h3 className="text-2xl sm:text-3xl sm:col-span-2 font-bold text-primario border-l-4 border-yellow-1 pl-3">
              Objetivos personales
            </h3>
            <p className="col-span-2">
              {" "}
              Selecciona una o varias razones por las que deseas tomar el curso.
            </p>

            {goalOptions.map((option) => (
              <label
                key={option}
                className="col-span-2 md:col-span-1 flex items-center gap-3 p-3 border border-gray-200 rounded-lg cursor-pointer hover:border-yellow-1 transition"
              >
                <input
                  type="checkbox"
                  value={option}
                  checked={formData.motivos.includes(option)}
                  onChange={handleCheckboxChange}
                  className="accent-yellow-1"
                />
                <span className="text-sm sm:text-base">{option}</span>
              </label>
            ))}
            <label htmlFor="mensaje" className="col-span-2 gap-3">
              Escribe tus dudas, preguntas o información adicional que necesites
              sobre nuestros cursos de ingles o exámenes de certificacion.
              <textarea
                name="mensaje"
                value={formData.mensaje}
                onChange={handleChange}
                placeholder="Escribe tu mensaje..."
                className="w-full p-3 rounded-lg border border-gray-300 min-h-[120px] focus:outline-none focus:ring-2 focus:ring-yellow-1 focus:border-yellow-1 mt-3"
                required
              ></textarea>
            </label>
          </div>
        )}

        {/* STEP 4 */}
        {currentStep === 4 && (
          <div className="space-y-6">
            <div className="space-y-6">
              <h3 className="text-2xl sm:text-3xl font-bold text-primario border-l-4 border-yellow-1 pl-3">
                Todo listo para comenzar
              </h3>
              <p className="text-base">
                Solo falta un paso para completar tu registro. Confirma tu
                información.
              </p>
            </div>
            <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
              <p>
                <b>Nombre:</b> {formData.nombre ? formData.nombre : "--" }
              </p>
              <p>
                <b>Email:</b> {formData.email ? formData.email : "--"}
              </p>
            </div>

            <div className="flex flex-col gap-2">
              <p className="font-bold text-primario">
                ¿Te gustaria realizar un examen diagnóstico?
              </p>
              <label className="flex gap-2 items-center">
                <input
                  type="radio"
                  name="diagnostico"
                  value="Sí"
                  onChange={handleChange}
                  className="accent-yellow-1"
                  required
                />
                Sí
              </label>
              <label className="flex gap-2 items-center">
                <input
                  type="radio"
                  name="diagnostico"
                  value="No"
                  onChange={handleChange}
                  className="accent-yellow-1"
                />
                No
              </label>
            </div>

            <label className="flex gap-3 items-center text-sm bg-yellow-100 p-4 rounded-lg border border-yellow-1">
              <input
                type="checkbox"
                name="aceptaDatos"
                checked={formData.aceptaDatos}
                onChange={handleSingleCheck}
                className="accent-yellow-1"
                required
              />
              <span>
                Acepto la{" "}
                <a
                  href="/politica-de-datos"
                  target="_blank"
                  className="text-yellow-1 font-bold underline "
                >
                  política de tratamiento de datos
                </a>
              </span>
            </label>
          </div>
        )}

        {/* NAV */}
        <div className="flex flex-row justify-between gap-3 pt-4">
          {currentStep > 1 && (
            <button
              type="button"
              onClick={() => setCurrentStep(currentStep - 1)}
              className="px-5 py-2 border border-primario text-primario rounded-lg font-bold hover:bg-primario hover:text-white transition"
            >
              Volver
            </button>
          )}

          {currentStep < steps.length ? (
            <button
              type="button"
              onClick={() => setCurrentStep(currentStep + 1)}
              className="ml-auto px-5 py-2 bg-primario text-white rounded-lg font-bold hover:opacity-90 transition w-max flex flex-row gap-1"
            >
              Siguiente{" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="icon icon-tabler icons-tabler-outline icon-tabler-arrow-narrow-right"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M5 12l14 0" />
                <path d="M15 16l4 -4" />
                <path d="M15 8l4 4" />
              </svg>
            </button>
          ) : (
            <button
              type="submit"
              className="ml-auto px-6 py-3 bg-yellow-1 text-primario rounded-lg font-bold hover:opacity-90 transition w-max flex flex-row gap-1"
            >
              Enviar{" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="icon icon-tabler icons-tabler-outline icon-tabler-brand-telegram"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M15 10l-4 4l6 6l4 -16l-18 7l4 2l2 6l3 -4" />
              </svg>
            </button>
          )}
        </div>
      </form>
    </div>
  );
}

export default StepperForm;
